import AspectClearableLabel from "./AspectClearableLabel";

// AJB: need an apply button to close the menu?
export default function AspectToggle({
  label,
  icon,
  isSelected,
  onChange,
}: {
  label: string;
  icon: React.ReactNode;
  isSelected: boolean;
  onChange: (isSelected: boolean) => void;
}) {
  return (
    <AspectClearableLabel
      onClick={() => onChange(!isSelected)}
      icon={icon}
      label={label}
      selectedValues={isSelected ? [label] : undefined}
    />
  );
}
